<template>
  <v-card :key="event.event_id">
    <div class="d-flex px-3" v-for="val in vals" :key="val.text">
      <div style="font-weight: bold;">{{ val.text }}</div>
      <div class="ml-3">{{ val.val }}</div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ['event'],
  computed: {
    vals() {
      if(!this.event) return []
      const e = this.event
      return [
        { val: e.hitter_name, text: "Lyojä" },
        { val: e.hitter_id, text: "Lyojä id" },
      ]
    }
  }
}
</script>